<div class="textarea-counter">
  <textarea #messagefield name="message" class="rounded-0 border-0" [(ngModel)]='message' 
    [attr.placeholder]="placeholder" [maxLength]="maxLength" (keyup)="setMessage()"></textarea>
  <div class='message-counter text-right pt-2 pb-2 pr-3'>
    <span>Characters remaining: {{ maxLength - messagefield.value.length }}</span>
  </div>
</div>